import axios from 'axios'
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_SEARCH_SUBSTITUTE_PRODUCTS_BEGIN,
  MANAGE_SUBS_SEARCH_SUBSTITUTE_PRODUCTS_SUCCESS,
  MANAGE_SUBS_SEARCH_SUBSTITUTE_PRODUCTS_FAILURE,
  MANAGE_SUBS_SEARCH_SUBSTITUTE_PRODUCTS_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import { COMMON_DATE_FORMAT } from '../../../common/constants';
import moment from 'moment';
import { handleAsohAndPrice } from '../formattedSubsData';

export function searchSubstituteProducts(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_SEARCH_SUBSTITUTE_PRODUCTS_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const siteId = args.site[0]
      const splitFlag = args.originalItemUom == "EA" ? true : false
      const { originalItem, isFromOuts, totalOuts } = args
      delete args["isFromOuts"]
      delete args["totalOuts"]
      let conditions = args;
      const doRequest = axios.post(`${API_REQUEST_URL}/searchForSub`, conditions, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          let searchProducts = res.data
          let asohParams = {
            "businessUnitNumber": siteId,
            "products": []
          }
          let secondAsohParams = {
            "businessUnitNumber": siteId,
            "products": [
              {
                "splitFlag": !splitFlag,
                "supc": originalItem,
              }
            ]
          }
          let priceParams = {
            "businessUnitNumber": siteId,
            "customerAccount": args.customerNumber ? args.customerNumber : args.nationalId,
            "priceRequestDate": moment().format(COMMON_DATE_FORMAT),
            "priceType": "N",
            //"products": []
            "products": [
              {
                splitFlag,
                "supc": originalItem,
              }
            ]
          }
          // Add sub items with extra fields
          if (searchProducts.success) {
            searchProducts.data.forEach(subItem => {
              if (originalItem !== subItem.supc) {
                let productObj = {
                  supc: subItem.supc,
                  splitFlag: splitFlag,
                  //quantity: 1,
                  originalSupc: originalItem, // always set for sub items
                  subReasonCode: "5",
                };
                //if (subItem.subReasonCode) productObj.subReasonCode = subItem.subReasonCode;
                priceParams.products.push(productObj);
              }
            });
          }
          let subFrequencyParams = {
            "origItemNumber": originalItem,
            "site": siteId,
            "subItemNumbers": []
          }
          //let searchProducts = res.data
          if(searchProducts.success) {
            searchProducts.data.forEach(subItem => {
              if(originalItem != subItem.supc) {
                asohParams.products.push({
                  splitFlag,
                  "supc": subItem.supc
                })
                secondAsohParams.products.push({
                  "splitFlag": !splitFlag,
                  "supc": subItem.supc
                })
                priceParams.products.push({
                  splitFlag,
                  "supc": subItem.supc
                })
              }
              subFrequencyParams.subItemNumbers.push(subItem.supc)
            })
            const asohRequest = axios.post(`${API_REQUEST_URL}/availStockFromAOSH`, asohParams, {
              headers: {
                'Authorization': token,
              }
            });
            const secondAsohRequest = axios.post(`${API_REQUEST_URL}/availStockFromAOSH`, secondAsohParams, {
              headers: {
                'Authorization': token,
              }
            });
            const priceRequest = axios.post(`${API_REQUEST_URL}/fetchPriceForItem`, priceParams, {
              headers: {
                'Authorization': token,
              }
            });
            const subFrequencyRequest = axios.post(`${API_REQUEST_URL}/getSubFrequency`, subFrequencyParams, {
              headers: {
                'Authorization': token,
              }
            });
            // Promise.allSettled([asohRequest, priceRequest, subFrequencyRequest,secondAsohRequest]).then(
            //   (results) => {
            //     const isAsohSuccess = results[0].status === "fulfilled" && Array.isArray(results[0].value.data)
            //     const isSecondAsohSuccess = results[3].status === "fulfilled" && Array.isArray(results[0].value.data)
            //     const isPriceSuccess = results[1].status === "fulfilled" && Array.isArray(results[1].value.data)
            //     const isSubFrequencySuccess = results[2].status === "fulfilled"
            //     const asohObg = {}
            //     const secondAsohObg={}
            //     const priceObg = {}
            //     const subFrequencyObg = {}
            //     if(isSubFrequencySuccess) {
            //       const subFrequencyrr = results[2].value.data.subFrequencies
            //       if(subFrequencyrr) {
            //         subFrequencyrr.forEach(item => {
            //           subFrequencyObg[item.origItemNumber] = item
            //         })
            //       }
            //     }
            //     if(isAsohSuccess) {
            //       const asohArr = results[0].value.data
            //       asohArr.forEach(item => {
            //         asohObg[item.supc] = item
            //       })
            //     }
            //     if(isSecondAsohSuccess) {
            //       const asohArr = results[3].value.data
                  
            //       asohArr.forEach(item => {
            //         secondAsohObg[item.supc] = item
            //       })
            //     }
            //     if(isPriceSuccess) {
            //       const priceArr = results[1].value.data
            //       priceArr.forEach(item => {
            //         priceObg[item.supc] = item
            //       })
            //     }
            //     handleAsohAndPrice(searchProducts, isFromOuts, isAsohSuccess, asohObg, isPriceSuccess, priceObg, isSubFrequencySuccess, subFrequencyObg, totalOuts,isSecondAsohSuccess,secondAsohObg)
            //     dispatch({
            //       type: MANAGE_SUBS_SEARCH_SUBSTITUTE_PRODUCTS_SUCCESS,
            //       data: searchProducts,
            //     });
            //     resolve(searchProducts);
            //   }
            // )
            Promise.allSettled([asohRequest, priceRequest, subFrequencyRequest, secondAsohRequest]).then(
              (results) => {
                const isAsohSuccess = results[0].status === "fulfilled" && Array.isArray(results[0].value.data)
                const isSecondAsohSuccess = results[3].status === "fulfilled" && Array.isArray(results[0].value.data)
                const isPriceSuccess = results[1].status === "fulfilled" && Array.isArray(results[1].value.data)
                const isSubFrequencySuccess = results[2].status === "fulfilled"
                const asohObg = {}
                const secondAsohObg={}
                const priceObg = {}
                const subFrequencyObg = {}
                let isPricePerNetWeightSuccess = false;
                const pricePerNetWeightObg = {};
                if(isSubFrequencySuccess) {
                  const subFrequencyrr = results[2].value.data.subFrequencies
                  if(subFrequencyrr) {
                    subFrequencyrr.forEach(item => {
                      subFrequencyObg[item.origItemNumber] = item
                    })
                  }
                }
                if(isAsohSuccess) {
                  const asohArr = results[0].value.data
                  asohArr.forEach(item => {
                    asohObg[item.supc] = item
                  })
                }
                if(isSecondAsohSuccess) {
                  const asohArr = results[3].value.data
                  
                  asohArr.forEach(item => {
                    secondAsohObg[item.supc] = item
                  })
                }
                if(isPriceSuccess) {
                  const priceArr = results[1].value.data
                  priceArr.forEach(item => {
                    priceObg[item.supc] = item
                  })
                }

                const subItemsDetails = searchProducts.data
                  .filter(subItem => subItem.supc !== originalItem)
                  .map(subItem => {
                    const supc = subItem.supc;
                    const priceProduct = priceParams.products.find(p => p.supc === supc) || {};
                    return {
                      netPrice: (priceObg[supc] && priceObg[supc].netPrice !== null && priceObg[supc].netPrice !== undefined) ? priceObg[supc].netPrice : 0,
                      netWeight: (subItem.site_details && subItem.site_details[0] && subItem.site_details[0].net_weight !== null && subItem.site_details[0].net_weight !== undefined) ? subItem.site_details[0].net_weight : 0,
                      splitFlag: priceProduct.splitFlag !== undefined ? priceProduct.splitFlag : splitFlag,
                      subItem: supc,
                      unitsPerCase: (priceObg[supc] && priceObg[supc].unitsPerCase !== null && priceObg[supc].unitsPerCase !== undefined) ? priceObg[supc].unitsPerCase : 0,
                      weightUom:
                        subItem.site_details?.[0]?.weight_uom ||
                        subItem.site_details?.[0]?.weightUom ||
                        subItem.weight_uom ||
                        subItem.weightUom ||
                        '',
                    };
                  });

                // get original item's splitFlag and unitsPerCase (fallbacks)
                const originalPriceProduct = priceParams.products.find(p => p.supc === originalItem) || {};
                const originalSplitFlag = originalPriceProduct.splitFlag !== undefined ? originalPriceProduct.splitFlag : splitFlag;
                const originalUnitsPerCase = (priceObg[originalItem] && priceObg[originalItem].unitsPerCase !== null && priceObg[originalItem].unitsPerCase !== undefined) ? priceObg[originalItem].unitsPerCase : 0;

                const originalItemNetPrice = (priceObg[originalItem] && priceObg[originalItem].netPrice !== null && priceObg[originalItem].netPrice !== undefined) ? priceObg[originalItem].netPrice : 0;

                const pricePerNetWeightRequest = axios.post(
                  `${API_REQUEST_URL}/fetchPricePerNetWeight`,
                  {
                    originalItem,
                    originalItemNetPrice,
                    site: siteId,
                    splitFlag: originalSplitFlag,
                    subItemsDetails,
                    unitsPerCase: originalUnitsPerCase,
                  },
                  { headers: { Authorization: token } }
                );

                return pricePerNetWeightRequest
                  .then(pricePerNetWeightRes => {
                    const pricePerNetWeightData = Array.isArray(pricePerNetWeightRes.data) ? pricePerNetWeightRes.data : [];
                    searchProducts.pricePerNetWeight = pricePerNetWeightData;

                    pricePerNetWeightData.forEach(item => {
                      if (item && item.supc) {
                        pricePerNetWeightObg[item.supc] = item;
                      }
                    });

                    isPricePerNetWeightSuccess = true;
                  })
                  .catch(() => {
                    searchProducts.pricePerNetWeight = null;
                    isPricePerNetWeightSuccess = false;
                  })
                  .finally(() => {
                    handleAsohAndPrice(
                      searchProducts,
                      isFromOuts,
                      isAsohSuccess,
                      asohObg,
                      isPriceSuccess,
                      priceObg,
                      isSubFrequencySuccess,
                      subFrequencyObg,
                      totalOuts,
                      isSecondAsohSuccess,
                      secondAsohObg,
                      isPricePerNetWeightSuccess,
                      pricePerNetWeightObg,
                      originalItem,
                    );
                dispatch({
                  type: MANAGE_SUBS_SEARCH_SUBSTITUTE_PRODUCTS_SUCCESS,
                  data: searchProducts,
                });
                resolve(searchProducts);
            });
              }
            )
          } else {
            //const errMsg = 'There is an error. Please refresh page or contact administrator.'
            const errMsg = searchProducts.message || 'There is an error. Please refresh page or contact administrator.'; //COT-10152
            dispatch({
              type: MANAGE_SUBS_SEARCH_SUBSTITUTE_PRODUCTS_FAILURE,
              data: { error: errMsg },
            });
            reject(errMsg);
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_SEARCH_SUBSTITUTE_PRODUCTS_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSearchSubstituteProductsError() {
  return {
    type: MANAGE_SUBS_SEARCH_SUBSTITUTE_PRODUCTS_DISMISS_ERROR,
  };
}

export function useSearchSubstituteProducts() {
  const dispatch = useDispatch();

  const { searchSubstituteProductsPending, searchSubstituteProductsError } = useSelector(
    state => ({
      searchSubstituteProductsPending: state.manageSubs.searchSubstituteProductsPending,
      searchSubstituteProductsError: state.manageSubs.searchSubstituteProductsError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(searchSubstituteProducts(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissSearchSubstituteProductsError());
  }, [dispatch]);

  return {
    searchSubstituteProducts: boundAction,
    searchSubstituteProductsPending,
    searchSubstituteProductsError,
    dismissSearchSubstituteProductsError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_SEARCH_SUBSTITUTE_PRODUCTS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        searchSubstituteProductsPending: true,
        searchSubstituteProductsError: null,
      };

    case MANAGE_SUBS_SEARCH_SUBSTITUTE_PRODUCTS_SUCCESS:
      // The request is success
      return {
        ...state,
        substituteProducts: action.data,
        searchSubstituteProductsPending: false,
        searchSubstituteProductsError: null,
      };

    case MANAGE_SUBS_SEARCH_SUBSTITUTE_PRODUCTS_FAILURE:
      // The request is failed
      return {
        ...state,
        searchSubstituteProductsPending: false,
        searchSubstituteProductsError: action.data.error,
      };

    case MANAGE_SUBS_SEARCH_SUBSTITUTE_PRODUCTS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        searchSubstituteProductsError: null,
      };

    default:
      return state;
  }
}